import { render, staticRenderFns } from "./NotificationStack.vue?vue&type=template&id=fff0f432&scoped=true"
import script from "./NotificationStack.vue?vue&type=script&lang=ts"
export * from "./NotificationStack.vue?vue&type=script&lang=ts"
import style0 from "./NotificationStack.vue?vue&type=style&index=0&id=fff0f432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff0f432",
  null
  
)

export default component.exports